<template>
  <div class="container">
    <div class="table-page-search-wrapper">
      <div>
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="7" :sm="7" v-if="handleOptionsData()">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据状态">
                <a-radio-group :default-value="null" :options="typeOption" @change="onTypeChange1" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据类型">
                <a-radio-group :options="typeOptions" default-value="4" @change="onTypeChange" />
              </a-form-item>
            </a-col>
            <a-col :md="9" :sm="9">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间">
                <a-range-picker
                  v-if="queryParam.dataType == 1"
                  style="width: 300px"
                  :allowClear="false"
                  :value="value"
                  @change="onallChange"
                />

                <a-range-picker
                  v-else-if="queryParam.dataType == 2"
                  :placeholder="['开始月份', '结束月份']"
                  format="YYYY-MM"
                  :value="value"
                  :mode="mode2"
                  @panelChange="handlePanelChange2"
                  @change="onallChange1"
                />
                <year-range v-else-if="queryParam.dataType == 3" @change="onYearRangeChange"></year-range>

                <a-range-picker
                  v-else-if="queryParam.dataType == 4"
                  style="width: 350px"
                  :showTime="true"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  :value="value"
                  @change="onDateChange"
                  @ok="onDateOk"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <a-button
                type="primary"
                style="margin: 0 10px"
                icon="download"
                @click="handleExportXls(`综合报表(${name}).xls`)"
                >导出
              </a-button>
              <a-button @click="openCol" icon="menu-unfold" type="primary" ghost> </a-button>
            </a-col>

            <!--<a-col :md="24" :sm="24" style="margin: 10px 0" v-if="colShow">-->
            <!--<a-checkbox-->
            <!--style="margin-right: 10px"-->
            <!--:indeterminate="indeterminate"-->
            <!--:checked="checkAll"-->
            <!--@change="onCheckAllChange"-->
            <!--&gt;-->
            <!--全选-->
            <!--</a-checkbox>-->
            <!--<a-checkbox-group v-model="selectCol" name="checkboxgroup" :options="options" @change="onChange" />-->
            <!--</a-col>-->
          </a-row>
        </a-form>
        <col-control ref="colControl" :options="options" @onChange="onChange"></col-control>
        <!-- 数据展示 -->
        <data-card :dataDetail="dataDetail" :quantum="quantime"></data-card>
      </div>
    </div>
    <div>
      <a-table
        id="tb"
        ref="table"
        size="middle"
        bordered
        :scroll="scroll"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
      ></a-table>
    </div>
  </div>
</template>
<script>
import colControl from '@/components/colControl/colControl'
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import { ChangeColMixin } from '@/mixins/ChangeColMixin1'
import moment from 'moment'
import { downloadFile } from '@/api/manage'
import yearRange from '@/components/date/yearRange'
import dataCard from './com/dataCard'
import dateSelect from '@/components/date/dateSelect'

export default {
  name: 'St21Cn2061ReportCustom',
  components: {
    yearRange,
    dataCard,
    colControl,
    dateSelect,
  },
  data() {
    return {
      typeOption: [
        {
          label: '综合数据',
          value: null,
        },
        {
          label: '生产数据',
          value: '1',
        },
        {
          label: '未生产数据',
          value: '2',
        }
      ],
      isPagination: false,
      isReport: true,
      mode2: ['month', 'month'],
      value: [],
      typeOptions: [
        {
          label: '实时值',
          value: '4',
        },
        {
          label: '日均值',
          value: '1',
        },
        {
          label: '月均值',
          value: '2',
        },
        {
          label: '年均值',
          value: '3',
        }
      ],
      name: '日均值',
      exportUrl: '',
      scroll: {
        y: 490,
      },
      siteName: '',
      moment,
      showSite: true,
      siteOnly: true,
    }
  },
  mixins: [GetSiteIdMixin, ChangeColMixin],
  props: ['showSiteTree','siteId','selectType'],
  watch: {
    currentSiteId(value) {
      if(this.showSite){
        var ids = this.getTreeCurrentId()
        this.queryParam.scope = ids[0]
        this.queryParam.scopeId = ids[1]
        this.checkAll = true
        this.indeterminate = false
        if (this.url) this.delayLoadData()
        if (ids[0] == 1) {
          if(this.siteType!=31){
            delete this.queryParam.productionStatus
          }
        }
      }
    },
    siteId:{
      handler(value){
        this.queryParam.scope = 1
        this.queryParam.scopeId = value
        this.checkAll = true
        this.indeterminate = false
        if(this.selectType){
          this.url = '/online/st' + this.selectType + '/report'
          this.exportUrl = `online/st${this.selectType}/export`
          window.addEventListener('setItem', (e) => {
            if (e.key == 'siteType') {
              this.siteType = this.selectType
              this.url = '/online/st' + this.selectType + '/report'
              this.exportUrl = `online/st${this.selectType}/export`
            }
          })
          if (this.url) this.delayLoadData()
        }
        if(this.selectType!=31){
          delete this.queryParam.productionStatus
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler(value){
        if(value === false){
          this.showSite = false
        }
      },
      deep: true,
      immediate:true
    },
    currentSiteName(value) {
      this.siteName = value
    },
  },
  computed: {
    quantime() {
      return this.queryParam.stime + '~' + this.queryParam.etime
    },
  },
  created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'day'),
      max: moment().endOf('day'),
    }
    this.$nextTick(() => {
      this.queryParam.order = 'asc'
    })
    this.value = [this.limitSelectDate.min, this.limitSelectDate.max]
    this.queryParam.type = 6
    this.queryParam.dataType = 4
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss')
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss')
    if(this.selectType){
      this.url = '/online/st' + this.selectType + '/report'
      this.exportUrl = `online/st${this.selectType}/export`
      window.addEventListener('setItem', (e) => {
        if (e.key == 'siteType') {
          this.siteType = this.selectType
          this.url = '/online/st' + this.selectType + '/report'
          this.exportUrl = `online/st${this.selectType}/export`
        }
      })
      if (this.url) this.delayLoadData()
    }else{
      this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/report'
      this.exportUrl = `online/st${window.sessionStorage.getItem('siteType')}/export`
      window.addEventListener('setItem', (e) => {
        if (e.key == 'siteType') {
          this.siteType = window.sessionStorage.getItem('siteType')

          this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/report'
          this.exportUrl = `online/st${window.sessionStorage.getItem('siteType')}/export`
        }
      })
    }
  },
  methods: {
    onTypeChange(e) {
      this.queryParam.dataType = e.target.value
      this.typeOptions.forEach((item, index) => {
        if (item.value == e.target.value) {
          this.name = item.label
        }
      })
      if (this.queryParam.dataType == 2) {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM')
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM')
        this.value = [this.limitSelectDate.min, this.limitSelectDate.max]
      }
      if (this.queryParam.dataType == 1) {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD')
        this.value = [this.limitSelectDate.min, this.limitSelectDate.max]
      }
      if (this.queryParam.dataType == 4) {
        console.log('stime=' + moment().subtract(1, 'weeks').format('YYYY-MM-DD HH:mm:ss'))
        console.log('stime=' + moment().format('YYYY-MM-DD HH:mm:ss'))
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss')
        this.value = [this.limitSelectDate.min, this.limitSelectDate.max]
      }
      this.$forceUpdate()
    },
    // 时间区间变化
    onallChange: function (date, dateString) {
      this.value = date
      this.queryParam.stime = dateString[0]
      this.queryParam.etime = dateString[1]
    },
    handlePanelChange2(value, mode) {
      console.log('handlePanel', value, mode)
      this.value = value
      this.queryParam.stime = value[0].format('YYYY-MM')
      this.queryParam.etime = value[1].format('YYYY-MM')
      this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
    },
    onYearRangeChange: function (value) {
      this.queryParam.stime = value[0] + ''
      this.queryParam.etime = value[1] + ''
    },
    onDateChange: function (value, dateString) {
      console.log(value, dateString)
      this.queryParam.stime = dateString[0]
      this.queryParam.etime = dateString[1]
      this.value = dateString[0]?[moment(dateString[0]), moment(dateString[1])]:null
      // this.loadData()
    },
    onDateOk(value) {
      console.log(value)
    },
    onTypeChange1(e){
      console.log('e',e)
      this.queryParam.productionStatus = e.target.value

    }
  },
}
</script>
<style lang="less" scoped>
.container {
  padding: 10px 20px 30px;
  box-sizing: border-box;
}

.redText {
  color: red;
  cursor: pointer;
}

.statusText {
  color: #000;
  padding: 3px 10px;
  border-radius: 10px;
}
</style>
